// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'swipe-left-solid';

export const Component = () => (
  <path d='M14.32 2.006c-.718.048-1.34.288-1.82.814-.526.527-.766 1.102-.766 1.82v6.897l-7.854 2.92v9.819h13.745l5.364-6.37c.527-.766.623-1.58.383-2.442-.288-.862-.767-1.437-1.39-1.677-.67-.239-1.292-.19-1.915.192L16.62 16.42V4.64c.096-.67-.096-1.293-.527-1.82-.526-.526-1.149-.814-1.772-.814Zm4.263 2.634v-.958h5.843v.958h-5.843ZM0 4.16l3.4 3.162.671-.719L1.964 4.64h8.046v-.958H1.964l2.107-1.916L3.401 1 0 4.16Z' />
);

export const viewBox = '0 0 25 25';
